import api from "./api";

export const getGenerateReport = async (params) => {
  return api
    .get({
      endpoint: "/reports/generate",
      port: process.env.REACT_APP_PORT_PAYMENT,
      queryParam: params,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
